import React from 'react';
import styled from 'styled-components';
import { token } from '@bynder/design-system';
import { useNavigableItem } from '../../KeyboardNavigation';

interface Props {
	children: React.ReactNode;
	isSelected: boolean;
	icon: React.ReactNode;
	onSelect: () => void;
	onMouseDown: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function CustomChip({ children, isSelected, icon, onSelect, onMouseDown }: Props) {
	const { isActive, itemRef } = useNavigableItem<HTMLButtonElement>(onSelect, {
		afterSelect: 'none',
	});

	const selectAndStopPropagation = (e: React.MouseEvent<HTMLButtonElement>) => {
		e.stopPropagation();
		onSelect();
	};

	return (
		<ChipStyled
			ref={itemRef}
			onClick={selectAndStopPropagation}
			onMouseDown={onMouseDown}
			$isSelected={isSelected}
			$isActive={isActive}
		>
			<IconStyled $isSelected={isSelected}>{icon}</IconStyled>
			{children}
		</ChipStyled>
	);
}

const ChipStyled = styled.button<{ $isSelected: boolean; $isActive: boolean }>`
	display: inline-flex;
	align-items: center;
	height: 32px;
	padding: 0 12px;
	border: 0;
	border-radius: ${token.radiusPill};
	font-size: 14px;
	white-space: nowrap;
	cursor: pointer;
	outline: none;
	background-color: ${({ $isSelected, $isActive }) => {
		if ($isActive) {
			return $isSelected ? '#d0e7ff' : token.gray75;
		}

		return $isSelected ? '#ECF3FF' : '#f2f3f4';
	}};
	color: ${({ $isSelected }) => ($isSelected ? `${token.blue500}` : token.colorText)};

	&:hover {
		background-color: ${({ $isSelected }) => ($isSelected ? '#d0e7ff' : token.gray75)};
	}
`;

const IconStyled = styled.span<{ $isSelected: boolean }>`
	display: inline-flex;
	align-items: center;
	margin-right: ${token.spacing3};
	color: ${({ $isSelected }) => ($isSelected ? token.blue500 : token.colorText)};
`;
